import Utils from "./utils";
import 'flatpickr';
/* global wp, tinyMCE, KmClbScriptMain, getAddress */
class Users {
  constructor() {
    this.userPage = document.querySelector('.js-clb-user-page');

    if (!this.userPage) {
      return;
    }

    window.addEventListener('DOMContentLoaded', () => {
      this.wp = typeof wp === 'undefined' ? null : wp;
      this.tinyMCE = typeof tinyMCE === 'undefined' ? null : tinyMCE;
      this.recaptcha = typeof grecaptcha === 'undefined' ? null : grecaptcha;
      this.recaptchaKey = KmClbScriptMain?.recaptchaKey;
      this.getAddress = typeof getAddress === 'undefined' ? null : getAddress;
      this.getaddressDomainToken = KmClbScriptMain?.getaddressDomainToken;
      this.fileErrors = KmClbScriptMain?.fileErrors;

      this.passwordStrength = this.wp?.passwordStrength;
      this.i18n = this.wp?.i18n;
      this.pageType = this.userPage.dataset.pageType;
      this.form = this.userPage.querySelector(`.js-clb-${this.pageType}-form`);

      if (!this.form) {
        return;
      }

      this.loading = false;
      this.passwordStrong = false;

      this.classnames = {
        loading: 'is-loading',
        weak: 'is-weak',
        strong: 'is-strong',
        medium: 'is-medium',
        hidden: 'cls-hidden',
        hasHidden: 'has-hidden'
      };

      this.registration = {
        step: 1,
        email: '',
      }

      this.formNotices = this.form.querySelector('.js-clb-form-notices');
      this.submitButton = this.form.querySelector('.js-clb-form-submit');
      this.imageUploadFields = this.form.querySelectorAll('.js-clb-image-upload');
      this.conditionalFields = this.form.querySelectorAll('.js-clb-conditional-field');
      this.deleteAccountButton = document.querySelector('.js-clb-delete-account-button');
      this.packagesSelect = this.form.querySelector('.js-clb-package-select');
      this.registerStepFields = this.form.querySelectorAll('.js-register-step-field');
      this.dateFields = this.form.querySelectorAll('.js-date-field');

      this.dependantFieldsVisible = {};

      this.passwordPages = [
        'register',
        'profile-update',
        'update-pass',
      ];

      this.getAddressInit();
      this.passwordStrengthCheckerInit();
      this.formSubmitHandler();
      this.loggedOutNoticeHandler();
      this.imagesPreviewHandler();
      this.conditionalFieldsHandler();
      this.deleteAccountHandler();
      this.packagesSelectHandler();
      this.numberInputSetup();
      this.dateFieldsLoad();
    });
  }

  getAddressInit() {
    if (!this.getAddress || !this.getaddressDomainToken) {
      return;
    }

    const userMainField = 'user_address_line_1';
    const lsitingMainField = 'new_listing_address_1';

    const userAddressField = document.querySelector(`#${userMainField}`);
    const listingAddressField = document.querySelector(`#${lsitingMainField}`);
    let outputFields = {};
    let mainField = null;

    if (userAddressField) {
      mainField = userMainField;
      outputFields = {
        formatted_address_1: 'user_address_line_2',
        town_or_city: 'user_city',
        county: 'user_county',
        postcode: 'user_postcode'
      };
    } else if (listingAddressField) {
      mainField = lsitingMainField;
      outputFields = {
        formatted_address_1: 'new_listing_address_2',
        town_or_city: 'new_listing_city',
        county: 'new_listing_county',
        postcode: 'new_listing_postcode'
      };
    }

    if (outputFields) {
      this.getAddress.autocomplete(
        mainField,
        this.getaddressDomainToken,
        {
          output_fields: outputFields,
        }
      );
    }
  }

  deleteAccountHandler() {
    if (!this.deleteAccountButton) {
      return;
    }

    this.deleting = false;

    this.deleteAccountButton.addEventListener('click', () => {
      if (this.deleting) {
        return;
      }

      this.deleting = true;

      if (confirm('Are you sure you want to delete your account and all of your listings?')) {
        this.deleteAccountButton.classList.add(this.classnames.loading);
        Utils.ajaxRequest('km_clb_user_delete', {}).then(response => {
          let message = null;

          if (response?.error) {
            message = response.error;
          } else if (response?.success) {
            message = response.success;
          }

          this.deleting = false;
          this.deleteAccountButton.classList.remove(this.classnames.loading);

          this.formNotices.insertAdjacentHTML('afterbegin', message);

          this.formNotices.scrollIntoView({
            behavior:'smooth',
            block: 'center',
            inline: 'center',
          });

          setTimeout(() => {
            this.formNotices.innerHTML = '';
          }, 5000);
        });
      } else {
        this.deleting = false;
      }
    });
  }

  packagesSelectHandler() {
    if (!this.packagesSelect) {
      return;
    }

    const submitButtonLabelElement = this.submitButton.querySelector('span');
    const submitButtonLabel = submitButtonLabelElement.textContent;

    this.packagesSelect.addEventListener('change', (e) => {
      const { price, priceDisplay } = e.target.selectedOptions[0].dataset;
      let submitLabel = '';

      submitButtonLabelElement.textContent = submitButtonLabel;

      if (price === '0.00' || ! price) {
        submitLabel = '';
      } else {
        submitLabel = ` and pay ${priceDisplay}`;
      }

      submitButtonLabelElement.textContent += submitLabel;
    });

    this.packagesSelect.dispatchEvent(new Event('change'));
  }

  conditionalFieldsHandler() {
    if (!this.conditionalFields.length) {
      return;
    }

    this.conditionalFields.forEach((conditionalField) => {
      conditionalField.addEventListener('change', (e) => {
        let value = e.target.value;
        const name = e.target.getAttribute('name');

        if (e.target?.type === 'checkbox') {
          value = e.target.checked ? 1 : 0;
        }

        if (!this.dependantFieldsVisible[name]) {
          this.dependantFieldsVisible[name] = [];
        }

        //const dependantFields = this.form.querySelectorAll(`[data-conditional-name="${name}"][data-conditional-value="${value}"]`);
        const dependantFields = this.form.querySelectorAll(`[data-conditional-name="${name}"]`);

        if (this.dependantFieldsVisible[name].length) {
          this.dependantFieldsVisible[name].forEach((dependantField) => {
            dependantField.classList.add(this.classnames.hidden);
          });
        }

        if (dependantFields.length) {
          dependantFields.forEach(dependantField => {
            this.dependantFieldsVisible[name].push(dependantField);

            const conditionValue = dependantField.getAttribute('data-conditional-value');
            const valueNot = dependantField.getAttribute('data-conditional-not');

            const show = valueNot ? conditionValue != value : conditionValue == value;

            if (show) {
              dependantField.classList.remove(this.classnames.hidden);
            } else {
              dependantField.classList.add(this.classnames.hidden);
            }
          });
        }
      });
      conditionalField.dispatchEvent(new Event('change'));
    });
  }

  imagesPreviewHandler() {
    if (!this.imageUploadFields.length) {
      return;
    }

    const imagesToRemoveField = this.form.querySelector('input[name="edit_images_to_remove"]');
    const imagesToRemove = [];
    const sizeLimit = 4194304; // 4MB

    this.imageUploadFields.forEach((imageUploadField) => {
      const imageUploadInput = imageUploadField.querySelector('input');
      const imageUploadPreview = imageUploadField.querySelector('img');
      const figure = imageUploadField.querySelector('figure');
      const clearButton = imageUploadField.querySelector('.js-clb-image-upload-clear');
      const defaultImageUrl = imageUploadField.dataset.defaultImageUrl;
      const currentSrc = imageUploadPreview.src;
      const fieldName = imageUploadInput.getAttribute('name');

      imageUploadInput.addEventListener('change', () => {
        const file = imageUploadInput.files[0];

        if (!file) {
          imageUploadInput.value = '';
          imageUploadPreview.src = defaultImageUrl;
          return;
        }

        const reader = new FileReader();
        figure.classList.add(this.classnames.loading);

        reader.addEventListener('load', () => {
          imageUploadPreview.src = reader.result;
          figure.classList.remove(this.classnames.loading);

          if (imagesToRemove.includes(fieldName) && imagesToRemoveField) {
            const updatedImagesToRemove = imagesToRemove.filter((value) => value !== fieldName);
            imagesToRemoveField.value = updatedImagesToRemove.join(',');
          }

          if (file.size > sizeLimit) {
            imageUploadInput.value = '';
            imageUploadInput.parentElement.insertAdjacentHTML('beforeend', `<span class="js-file-error bg-red-50 text-red-800 p-1 text-xs">${this.fileErrors.size}</span>`);
          } else {
            imageUploadInput.parentElement.querySelector('.js-file-error')?.remove();
          }
        });

        if (imageUploadInput.classList.contains(this.classnames.hasHidden)) {
          const hiddenField = this.form.querySelector(`input[name="${imageUploadInput.dataset.hidden}"]`);

          if (hiddenField) {
            hiddenField.value = '';
          }
        }

        reader.readAsDataURL(file);
      });

      if (clearButton) {
        clearButton.addEventListener('click', (e) => {
          const removed = currentSrc !== defaultImageUrl;

          imageUploadInput.value = '';
          imageUploadPreview.src = defaultImageUrl;

          if (removed) {
            if (imagesToRemoveField) {
              if (!imagesToRemove.includes(fieldName)) {
                imagesToRemove.push(fieldName);
              }
              imagesToRemoveField.value = imagesToRemove.join(',');
            }

            const fieldContainer = clearButton.closest('.js-clb-image-upload');
            if (fieldContainer) {
              const hasHidden = fieldContainer.querySelector(`.${this.classnames.hasHidden}`);

              if (hasHidden) {
                const hiddenField = this.form.querySelector(`input[name="${hasHidden.dataset.hidden}"]`);

                if (hiddenField) {
                  hiddenField.value = '';
                }
              }
            }
          }
        });
      }
    });
  }

  loggedOutNoticeHandler() {
    const loggedOutParam = 'logged_out';
    const loggedOut = new URLSearchParams(window.location.search).get(loggedOutParam);

    if (loggedOut) {
      setTimeout(() => {
        this.formNotices.innerHTML = '';
        const url = new URL(window.location);
        url.searchParams.delete(loggedOutParam);
        window.history.replaceState({}, '', url);
      }, 3000);
    }
  }

  getPasswordStrength = (strengthValue, length) => {
    const tooWeak = this.i18n.__('Too weak. Add another word or two.');

    let strenght = strengthValue;

    if (length < 9) {
      strenght = 2;
    }

    switch (strenght) {
      case 3:
        return this.i18n.__('Medium. Good password.')
        break;
      case 4:
        return this.i18n.__('Strong. Very good password.')
        break;
      default:
        return tooWeak;
        break;
    }
  }

  passwordStrengthCheckerInit() {
    if (this.passwordPages.includes(this.pageType)) {
      this.passwordStrengthChecker();
    }
  }

  passwordStrengthChecker() {
    this.password = this.form.querySelector('#user_password');
    this.strengthMeter = this.form.querySelector('.js-clb-password-strength');
    if (this.passwordStrength && this.i18n && this.password) {
      // check password strenght on keyup
      this.password.addEventListener('keyup', () => {
        const strength = this.passwordStrength.meter(this.password.value, this.passwordStrength.userInputDisallowedList());
        const length = this.password.value.length;
        const strengthText = this.getPasswordStrength(strength, length);

        if (strengthText) {
          this.strengthMeter.classList.remove(this.classnames.hidden);
          this.strengthMeter.textContent = strengthText;
          this.passwordStrong = strength >= 3;
        }
        if (strength > 3) {
          this.strengthMeter.classList.remove(this.classnames.weak);
          this.strengthMeter.classList.remove(this.classnames.medium);
          this.strengthMeter.classList.add(this.classnames.strong);
        } else if (strength > 2) {
          this.strengthMeter.classList.remove(this.classnames.weak);
          this.strengthMeter.classList.remove(this.classnames.strong);
          this.strengthMeter.classList.add(this.classnames.medium);
        } else {
          this.strengthMeter.classList.remove(this.classnames.medium);
          this.strengthMeter.classList.remove(this.classnames.strong);
          this.strengthMeter.classList.add(this.classnames.weak);
        }
      });
    } else {
      this.passwordStrong = true;
    }
  }

  getCheckboxesValues = () => {
    const checkboxes = this.form.querySelectorAll('input[type="checkbox"]');
    const values = {};

    if (checkboxes.length) {
      Array.from(checkboxes).forEach((field) => {
        values[field.name] = field.checked ? 'yes' : 'no';
      });
    }

    return values;
  }

  generateRecaptchaToken = () => {
    return new Promise((res, rej) => {
      this.recaptcha.ready(() => {
        this.recaptcha.execute(this.recaptchaKey, {action: 'clb'}).then((token) => {
          return res(token);
        });
      });
    });
  }

  submitForm = (formValues) => {
    const ajaxAction = `km_clb_user_${this.pageType.replace('-', '_')}`;

    if (this.pageType === 'register') {
      formValues['registerStep'] = this.registration.step;
      formValues['registerEmail'] = this.registration.email;
    }

    Utils.ajaxRequest(ajaxAction, formValues).then(response => {
      let message = null;
      const clearMessage = response?.clearMessage || 'no';
      const scroll = response?.scroll || 'yes';
      const hideSubmit = response?.hideSubmit || 'no';
      const editModeSlug = response?.editModeSlug || null;

      if (editModeSlug) {
        const input = this.form.querySelector(`[name="edit_mode_slug"]`);

        if (input) {
          input.value = editModeSlug;
        }
      }

      if (response?.error) {
        message = response.error;
      } else if (response?.success) {
        message = response.success;

        if (this.pageType === 'register') {
          Utils.gaEvent('formSubmit', {
            'formName': 'registration'
          });
        }

        if (response?.redirect) {
          const timeout = response?.timeout || 3000;

          setTimeout(() => {
            window.location.href = response.redirect;
          }, timeout);
        }
      }

      if (message) {
        this.formNotices.insertAdjacentHTML('afterbegin', message);

        if (scroll === 'yes') {
          this.formNotices.scrollIntoView({
            behavior:'smooth',
            block: 'center',
            inline: 'center',
          });
        }
      }

      if (hideSubmit === 'yes') {
        this.submitButton.remove();
      }

      if (!response?.redirect) {
        this.submitButton.removeAttribute('disabled');
        this.loading = false;

        if (clearMessage === 'yes') {
          setTimeout(() => {
            this.formNotices.innerHTML = '';
          }, 3000);
        }
      }

      if (response?.registerFields) {
        this.registration.step = 2;
        this.registration.email = response.email;

        if (this.registerStepFields.length) {
          this.registerStepFields.forEach((field) => field.remove());
        }

        this.form.insertAdjacentHTML('afterbegin', response.registerFields);

        this.submitButton.querySelector('span').textContent = this.submitButton.dataset.label;

        this.passwordStrengthCheckerInit();
        this.getAddressInit();
        this.formNotices = this.form.querySelector('.js-clb-form-notices');
      }

      this.submitButton.classList.remove(this.classnames.loading);
    });
    this.loading = true;
  }

  formSubmitHandler() {
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();

      if (this.loading) {
        return;
      }

      if (this.tinyMCE) {
        tinyMCE.triggerSave();
      }

      const checkboxesValues = this.getCheckboxesValues();

      const formData = new FormData(this.form);
      let formValues = {};

      formData.forEach((value, key) => {
        formValues[key] = value;
      });

      formValues = { ...formValues, ...checkboxesValues };

      if (this.passwordPages.includes(this.pageType)) {
        formValues.strong_password = this.passwordStrong;
      }

      this.formNotices.innerHTML = '';
      this.submitButton.setAttribute('disabled', 'disabled');
      this.submitButton.classList.add(this.classnames.loading);

      this.recaptchaField = this.form.querySelector('.js-recaptcha');

      if (this.recaptcha && this.recaptchaField) {
        this.generateRecaptchaToken().then(token => {
          this.recaptchaField.value = token;
          formValues['recaptcha_response'] = token;

          this.submitForm(formValues);
        });
      } else {
        this.submitForm(formValues);
      }
    });
  }

  numberInputSetup() {
    const numberInputs = this.form.querySelectorAll('input[type="number"]');

    if (numberInputs.length) {
      numberInputs.forEach((input) => {
        input.addEventListener('mousewheel', (e) => {
          e.preventDefault();
        })
      });
    }
  }

  dateFieldsLoad() {
    if (this.dateFields.length) {
      this.dateFields.flatpickr({
        enableTime: false,
        mode: 'range',
        dateFormat: 'Y-m-d',
      });
    }
  }
}
export default Users;
